var React = require('react');

function ClockIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5 13.2402C10.0899 13.2402 13 10.3301 13 6.74023C13 3.15038 10.0899 0.240234 6.5 0.240234C2.91015 0.240234 0 3.15038 0 6.74023C0 10.3301 2.91015 13.2402 6.5 13.2402ZM9.5 8.74023C9.77614 8.74023 10 8.51638 10 8.24023C10 7.96409 9.77614 7.74023 9.5 7.74023H7V4.24023C7 3.96409 6.77614 3.74023 6.5 3.74023C6.22386 3.74023 6 3.96409 6 4.24023V8.74023H9.5Z","fill":"#333333"}));
}

ClockIcon.defaultProps = {"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none"};

module.exports = ClockIcon;

ClockIcon.default = ClockIcon;
